import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import voca from 'voca';

const iconColours = {
  Low: 'tw-bg-[#45B980]',
  Medium: 'tw-bg-[#FB6902]',
  High: 'tw-bg-[#C21B03]',
};

export default function LevelOfRisk({ option, subtextProps }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectCoshh.components.LevelOfRisk',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const text = i18nTShared(voca.lowerCase(option));

  return (
    <div className='tw-flex tw-items-center'>
      <div
        className={classNames(
          'tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-text-center tw-text-s tw-font-bold tw-text-white',
          iconColours[option],
        )}
      >
        {text[0]}
      </div>
      <div className='tw-pl-2'>
        <p className='tw-m-0 tw-font-medium'>{text}</p>
        <p
          className={classNames(
            'tw-m-0 tw-truncate tw-text-s tw-font-normal tw-tracking-wide',
            subtextProps?.className,
          )}
        >
          {i18nT(`description.${voca.lowerCase(option)}`)}
        </p>
      </div>
    </div>
  );
}

LevelOfRisk.propTypes = {
  option: PropTypes.oneOf(['Low', 'Medium', 'High']).isRequired,
  subtextProps: PropTypes.object,
};
